export default "__VITE_ASSET__h2fLa3MO__"